(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cg-before-after')) {
  customElements.define('cg-before-after', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.tabs = [...this.querySelectorAll('[role=tab]')];
      this.panels = [...this.querySelectorAll('[role=tabpanel]')];
      this.ranges = [...this.querySelectorAll('input[type=range]')];
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.select = (index, focus = false) => {
        if (!this.tabs.length) return;
        index = Math.max(0, Math.min(this.tabs.length - 1, index));
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[i].hidden = !active;
        });
        if (focus) this.tabs[index]?.focus();
      };
      this.select(Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true')));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); this.select(next, true); }
        }, options);
      });
      this.ranges.forEach(range => {
        const stage = range.closest('.cg-before-after__stage');
        const update = () => {
          const value = Math.max(0, Math.min(100, Number(range.value) || 0));
          stage.style.setProperty('--split', value + '%');
          range.setAttribute('aria-valuetext', range.dataset.positionTemplate.replace('__percent__', String(value)));
        };
        const move = event => {
          const box = stage.getBoundingClientRect();
          if (!box.width) return;
          range.value = String(Math.round(Math.max(0, Math.min(100, (event.clientX - box.left) / box.width * 100))));
          update();
        };
        range.addEventListener('input', update, options);
        range.addEventListener('pointerdown', event => {
          if (event.button !== 0 && event.pointerType === 'mouse') return;
          event.preventDefault();
          range.focus({ preventScroll: true });
          range.dataset.dragging = String(event.pointerId);
          range.setPointerCapture(event.pointerId);
          move(event);
        }, options);
        range.addEventListener('pointermove', event => {
          if (range.dataset.dragging === String(event.pointerId)) move(event);
        }, options);
        const stop = event => {
          if (range.dataset.dragging !== String(event.pointerId)) return;
          delete range.dataset.dragging;
          if (range.hasPointerCapture(event.pointerId)) range.releasePointerCapture(event.pointerId);
        };
        range.addEventListener('pointerup', stop, options);
        range.addEventListener('pointercancel', stop, options);
        range.addEventListener('lostpointercapture', () => { delete range.dataset.dragging; }, options);
        update();
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) this.select(index);
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.ranges?.forEach(range => { delete range.dataset.dragging; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-customer-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cg-customer-gallery')) {
  customElements.define('cg-customer-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cg-customer-gallery__track');
      this.cards = [...this.querySelectorAll('.cg-customer-gallery__card:not([data-gallery-clone])')];
      this.dots = [...this.querySelectorAll('.cg-customer-gallery__dot')];
      if (!this.track || !this.cards.length || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.current = 0;
      this.cards.forEach((card, index) => { card.dataset.galleryIndex = String(index); });
      this.centreOn = (card, behavior = 'instant') => {
        if (!card) return;
        const trackBox = this.track.getBoundingClientRect();
        const cardBox = card.getBoundingClientRect();
        this.track.scrollTo({
          left: this.track.scrollLeft + cardBox.left + cardBox.width / 2 - trackBox.left - trackBox.width / 2,
          behavior
        });
      };
      this.select = index => {
        clearTimeout(this.normalizeTimer);
        const next = ((index % this.cards.length) + this.cards.length) % this.cards.length;
        const box = this.track.getBoundingClientRect();
        const centre = box.left + box.width / 2;
        const matches = this.slides.filter(card => Number(card.dataset.galleryIndex) === next);
        const target = matches.reduce((closest, card) => {
          const distance = node => {
            const rect = node.getBoundingClientRect();
            return Math.abs(rect.left + rect.width / 2 - centre);
          };
          return !closest || distance(card) < distance(closest) ? card : closest;
        }, null);
        this.centreOn(target, matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
      };
      this.normalize = () => {
        const active = this.slides.find(card => card.classList.contains('is-active'));
        if (active?.hasAttribute('data-gallery-clone')) this.centreOn(this.cards[this.current]);
      };
      this.update = () => {
        const box = this.track.getBoundingClientRect();
        const centre = box.left + box.width / 2;
        let nearest = null;
        let distance = Infinity;
        this.slides.forEach(card => {
          const rect = card.getBoundingClientRect();
          const value = Math.abs(rect.left + rect.width / 2 - centre);
          if (value < distance) { nearest = card; distance = value; }
        });
        if (!nearest) return;
        this.current = Number(nearest.dataset.galleryIndex);
        this.slides.forEach(card => card.classList.toggle('is-active', card === nearest));
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.current)));
        clearTimeout(this.normalizeTimer);
        this.normalizeTimer = setTimeout(this.normalize, 180);
      };
      this.layout = () => {
        const width = this.track.clientWidth;
        if (!width || width === this.lastWidth) return;
        this.lastWidth = width;
        clearTimeout(this.normalizeTimer);
        this.track.querySelectorAll('[data-gallery-clone]').forEach(card => card.remove());
        const cardWidth = this.cards[0].offsetWidth;
        const count = this.cards.length > 1 && cardWidth ? Math.min(this.cards.length, Math.ceil(width / cardWidth)) : 0;
        const clone = card => {
          const copy = card.cloneNode(true);
          copy.setAttribute('data-gallery-clone', '');
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('inert', '');
          copy.classList.remove('is-active');
          [...copy.attributes].filter(attribute => attribute.name.startsWith('data-shopify')).forEach(attribute => copy.removeAttribute(attribute.name));
          copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          return copy;
        };
        if (count) {
          this.track.prepend(...this.cards.slice(-count).map(clone));
          this.track.append(...this.cards.slice(0, count).map(clone));
        }
        this.slides = [...this.track.querySelectorAll('.cg-customer-gallery__card')];
        this.centreOn(this.cards[this.current]);
        this.update();
      };
      this.layout();
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.update);
      }, { ...options, passive: true });
      this.track.addEventListener('scrollend', this.normalize, options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index), options));
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.select(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const selected = this.cards.indexOf(event.target.closest('.cg-customer-gallery__card'));
        if (selected >= 0) this.select(selected);
      }, options);
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(this.layout);
        this.resize.observe(this.track);
      }
      window.addEventListener('resize', this.layout, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.normalizeTimer);
      this.track?.querySelectorAll('[data-gallery-clone]').forEach(card => card.remove());
      this.lastWidth = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency:window.Shopify?.currency?.active || document.querySelector('[data-cg-cart]')?.dataset.money || 'GBP'}).format(cents/100);
  const bundleTotal = (subtotal, quantity) => {
    if ((window.Shopify?.currency?.active || 'GBP') !== 'GBP') return subtotal;
    return Math.max(0, subtotal - (quantity >= 3 ? 1801 : quantity >= 2 ? 800 : 0));
  };
  const request = async (path,options={}) => { const response=await fetch(root()+path,{...options,headers:{'Accept':'application/json',...options.headers}});const data=await response.json();if(!response.ok)throw new Error(data.description || data.message || 'Please try again.');return data; };
  const text = (tag,value,className='') => { const el=document.createElement(tag);el.textContent=value;el.className=className;return el; };
  let cartOpener=null;
  const closeCart=()=>{const dialog=document.querySelector('[data-cg-cart]');dialog?.close();cartOpener?.focus();};
  const renderCart=async(open=false)=>{const dialog=document.querySelector('[data-cg-cart]');if(!dialog)return;if(open&&!dialog.open)dialog.showModal();const status=dialog.querySelector('[data-cg-cart-status]');status.textContent=dialog.dataset.loading;try{const cart=await request('cart.js');const list=dialog.querySelector('[data-cg-cart-items]');list.replaceChildren();document.querySelectorAll('[data-cg-count]').forEach(el=>el.textContent=cart.item_count);if(!cart.items.length)list.append(text('p',dialog.dataset.empty));cart.items.forEach(item=>{const row=text('div','','cg-cart-row');if(item.image){const img=document.createElement('img');img.src=item.image+(item.image.includes('?')?'&':'?')+'width=160';img.alt=item.product_title;row.append(img);}const detail=document.createElement('div');detail.append(text('h3',item.product_title),text('p',item.variant_title || '', 'cg-small'),text('p',money(item.final_line_price),'cg-small'));if(item.properties?.['Pre-order'])detail.append(text('p',item.properties['Pre-order'],'cg-small cg-cart-preorder'));const controls=text('div','','cg-cart-actions');const input=document.createElement('input');input.type='number';input.min='0';input.step='1';input.value=item.quantity;input.setAttribute('aria-label',dialog.dataset.quantity+' '+item.title);const change=async(quantity)=>{input.disabled=true;try{await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity})});await renderCart();}catch(error){status.textContent=error.message;input.disabled=false;input.value=item.quantity;}};input.addEventListener('change',()=>{const n=Number(input.value);if(Number.isInteger(n)&&n>=0)change(n);else input.value=item.quantity;});const remove=text('button',dialog.dataset.remove,'cg-text-button');remove.type='button';remove.onclick=()=>change(0);controls.append(input,remove);detail.append(controls);row.append(detail);list.append(row);});dialog.querySelector('[data-cg-cart-total]').textContent=money(cart.total_price);const saving=dialog.querySelector('[data-cg-cart-saving]');saving.hidden=cart.total_discount<=0;saving.textContent=dialog.dataset.saving+' '+money(cart.total_discount);status.textContent='';}catch(error){status.textContent=error.message || dialog.dataset.error;}};
  document.addEventListener('click',event=>{const opener=event.target.closest('[data-cg-open-cart]');if(opener){event.preventDefault();cartOpener=opener;renderCart(true);}if(event.target.closest('[data-cg-close]'))closeCart();if(event.target.matches('[data-cg-cart]')&&event.clientX<event.target.getBoundingClientRect().left)closeCart();if(event.target.closest('.cg-mobile-menu a'))event.target.closest('details').open=false;});
  const add=async(items,button,status)=>{button.disabled=true;button.setAttribute('aria-busy','true');status.textContent='';try{await request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});cartOpener=button;await renderCart(true);return true;}catch(error){status.textContent=error.message;return false;}finally{button.disabled=false;button.removeAttribute('aria-busy');}};
  const activeOffer = scope => scope.querySelector('[data-cg-offer]:has(.cg-offer-summary input:checked)');
  const offerSelects = scope => Array.from(activeOffer(scope)?.querySelectorAll('[data-cg-jar]') || []);
  const updateOffers = scope => {
    scope.querySelector('[data-cg-packs]').hidden = false;
    scope.querySelectorAll('[data-cg-offer]').forEach(card => {
      const radio = card.querySelector('.cg-offer-summary input');
      const panel = card.querySelector('[data-cg-offer-panel]');
      panel.hidden = !radio.checked;
      let subtotal = 0;
      card.querySelectorAll('[data-cg-jar]').forEach(select => {
        select.disabled = !radio.checked;
        const option = select.selectedOptions[0];
        subtotal += Number(option?.dataset.price || 0);
        const image = select.closest('.cg-offer-jar').querySelector('[data-cg-jar-image]');
        if (image && option?.dataset.image) {
          image.src = option.dataset.image;
          image.removeAttribute('srcset');
        }
      });
      card.querySelector('[data-cg-offer-price]').textContent = money(bundleTotal(subtotal, Number(radio.value)));
    });
  };
  const purchaseLabel = (scope, count) => {
    if (scope.dataset.preorderDate) return count === 1 ? scope.dataset.preorderSolo : count === 2 ? scope.dataset.preorderDuo : scope.dataset.preorderTrio;
    return count === 1 ? scope.dataset.add : scope.dataset.addColours.replace('__COUNT__', String(count));
  };
  const offerItems = scope => {
    scope.querySelector('cg-preorder-box')?.refreshDate?.();
    const lines = new Map();
    offerSelects(scope).forEach(select => lines.set(Number(select.value), (lines.get(Number(select.value)) || 0) + 1));
    return Array.from(lines, ([id, quantity]) => scope.dataset.preorderDate ? { id, quantity, properties: { 'Pre-order': scope.dataset.preorderLabel } } : { id, quantity });
  };
  if (!customElements.get('cg-product')) customElements.define('cg-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-cg-variants]').textContent);
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-cg-status]');
      this.button = this.querySelector('[data-cg-add]');
      this.sticky = this.querySelector('[data-cg-sticky-add]');
      this.addEventListener('change', event => {
        if (event.target.name === 'cg_pack') this.select(offerSelects(this)[0]?.value, true);
        else if (event.target.matches('[data-cg-jar]')) {
          if (event.target.dataset.jarIndex === '1') this.select(event.target.value, true);
          else this.syncTotal();
        }
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-cg-thumb]');
        if (thumb) {
          const image = this.querySelector('[data-cg-main-image]');
          image.src = thumb.dataset.cgThumb;
          image.removeAttribute('srcset');
          image.alt = thumb.dataset.alt;
          this.querySelectorAll('[data-cg-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el === thumb)));
        }
        if (event.target.closest('[data-cg-sticky-add]')) this.form.requestSubmit(this.button);
      });
      this.form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy || !this.form.reportValidity() || !this.selectedJars().every(v => v?.available)) return;
        this.busy = true;
        this.syncTotal();
        await add(offerItems(this), this.button, this.status);
        this.busy = false;
        this.syncTotal();
      });
      this.select(new URL(location.href).searchParams.get('variant') || this.querySelector('[name=id]')?.value, false);
      this.observer = new IntersectionObserver(entries => this.querySelector('[data-cg-sticky]').classList.toggle('cg-sticky-visible', !entries[0].isIntersecting), { threshold: 0 });
      this.observer.observe(this.button);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    selectedJars() { return offerSelects(this).map(select => this.variants.find(variant => String(variant.id) === select.value)); }
    select(id, update) {
      this.selected = this.variants.find(variant => String(variant.id) === String(id)) || this.variants.find(variant => variant.available) || this.variants[0];
      if (!this.selected) return;
      const variant = this.selected;
      const first = offerSelects(this)[0];
      if (first) first.value = String(variant.id);
      this.querySelector('[name=id]').value = variant.id;
      const image = this.querySelector('[data-cg-main-image]');
      if (image && variant.image) {
        image.src = variant.image;
        image.removeAttribute('srcset');
        image.alt = variant.title + ' — ' + this.dataset.title;
        this.querySelectorAll('[data-cg-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.cgThumb === variant.image)));
      }
      const swatch = this.querySelector('[data-cg-sticky-colour]');
      if (swatch) swatch.style.background = first?.selectedOptions[0]?.dataset.shade || '#990f35';
      if (update) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      this.status.textContent = '';
      this.syncTotal();
      document.dispatchEvent(new CustomEvent('cg:shade', { detail: { title: variant.title } }));
    }
    syncTotal() {
      updateOffers(this);
      const jars = this.selectedJars();
      const valid = jars.length > 0 && jars.every(variant => variant?.available);
      const total = bundleTotal(jars.reduce((sum, variant) => sum + (variant?.price || 0), 0), jars.length);
      const label = purchaseLabel(this, jars.length);
      this.button.disabled = !valid || this.busy;
      this.sticky.disabled = !valid || this.busy;
      this.button.textContent = valid ? label + ' — ' + money(total) : this.dataset.sold;
      this.sticky.textContent = this.button.textContent;
      this.querySelector('[data-cg-sticky-price]').textContent = money(total);
      this.querySelector('[data-cg-sticky-label]').textContent = activeOffer(this).querySelector('.cg-pack-title').textContent;
    }
  });
  if(!customElements.get('cg-stories'))customElements.define('cg-stories',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',e=>{const filter=e.target.closest('[data-cg-filter]');if(filter){const shade=filter.dataset.cgFilter;this.querySelectorAll('[data-cg-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filter)));this.querySelectorAll('[data-cg-story]').forEach(card=>{card.hidden=shade!=='all'&&card.dataset.cgStory!==shade;card.querySelector('video')?.pause();});}const scroll=e.target.closest('[data-cg-scroll]');if(scroll){const rail=this.querySelector('[data-cg-rail]');rail.scrollBy({left:Number(scroll.dataset.cgScroll)*rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}});}});
  if(!customElements.get('cg-comparison'))customElements.define('cg-comparison',class extends HTMLElement{connectedCallback(){this.querySelectorAll('input[type=range]').forEach(input=>input.addEventListener('input',()=>input.closest('.cg-compare-images').style.setProperty('--split',input.value+'%')));}});
  if (!customElements.get('cg-bundle')) customElements.define('cg-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-cg-bundle-add]');
      this.status = this.querySelector('[data-cg-status]');
      this.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy || !this.form.reportValidity() || offerSelects(this).some(s => !s.selectedOptions[0] || s.selectedOptions[0].disabled)) return;
        this.busy = true;
        this.update();
        await add(offerItems(this), this.button, this.status);
        this.busy = false;
        this.update();
      });
      this.update();
    }
    update() {
      updateOffers(this);
      const selects = offerSelects(this);
      const available = selects.length > 0 && selects.every(select => select.selectedOptions[0] && !select.selectedOptions[0].disabled);
      const total = bundleTotal(selects.reduce((sum, select) => sum + Number(select.selectedOptions[0]?.dataset.price || 0), 0), selects.length);
      this.querySelector('[data-cg-bundle-total]').textContent = money(total);
      const label = purchaseLabel(this, selects.length);
      this.button.textContent = available ? label + ' — ' + money(total) : this.dataset.sold;
      this.button.disabled = !available || this.busy;
    }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cg-reviews-slider')) {
  customElements.define('cg-reviews-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.cg-reviews-slider__track');
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      this.dots = [...this.querySelectorAll('[data-review-index]')];
      this.modal = this.querySelector('dialog');
      if (!this.track) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.current = 0;
      this.step = () => this.cards.length ? this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0) : 0;
      this.go = (index, behavior) => {
        if (!this.looping) return;
        this.track.scrollTo({ left: (this.cloneCount + index) * this.step(), behavior: behavior || (matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth') });
      };
      this.layout = () => {
        const visible = matchMedia('(min-width:1024px)').matches ? 3 : matchMedia('(min-width:768px)').matches ? 2 : 1;
        if (visible === this.visible) { this.go(this.current, 'auto'); return; }
        this.visible = visible;
        this.track.querySelectorAll('[data-review-clone]').forEach(card => card.remove());
        this.looping = this.cards.length > visible;
        this.cloneCount = this.looping ? Math.min(3, this.cards.length) : 0;
        const clone = card => {
          const copy = card.cloneNode(true);
          copy.removeAttribute('data-review-card');
          copy.setAttribute('data-review-clone', '');
          copy.setAttribute('aria-hidden', 'true');
          [...copy.attributes].filter(attr => attr.name.startsWith('data-shopify')).forEach(attr => copy.removeAttribute(attr.name));
          copy.querySelectorAll('button').forEach(button => button.tabIndex = -1);
          return copy;
        };
        if (this.looping) {
          this.track.prepend(...this.cards.slice(-this.cloneCount).map(clone));
          this.track.append(...this.cards.slice(0, this.cloneCount).map(clone));
        }
        this.querySelector('.cg-reviews-slider__pagination')?.toggleAttribute('hidden', !this.looping);
        this.querySelector('[data-pause-reviews]')?.toggleAttribute('hidden', !this.looping);
        this.go(this.current, 'auto');
      };
      this.update = () => {
        const step = this.step();
        if (!this.looping || !step) return;
        const raw = Math.round(this.track.scrollLeft / step) - this.cloneCount;
        this.current = ((raw % this.cards.length) + this.cards.length) % this.cards.length;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.current)));
        clearTimeout(this.normalizeTimer);
        this.normalizeTimer = setTimeout(() => {
          const settled = Math.round(this.track.scrollLeft / this.step()) - this.cloneCount;
          if (settled < 0 || settled >= this.cards.length) this.go(this.current, 'auto');
        }, 160);
      };
      this.layout();
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i), options));
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !this.looping) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.returnFocus = () => {
        if (this.savedOverflow !== undefined) { document.body.style.overflow = this.savedOverflow; this.savedOverflow = undefined; }
        this.trigger?.focus({ preventScroll: true });
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-read-review]');
        if (!button || !this.contains(button)) return;
        this.trigger = button;
        this.modal.querySelector('.cg-reviews-slider__modal-text').textContent = button.dataset.fullReview;
        this.modal.querySelector('.cg-reviews-slider__modal-author').textContent = button.dataset.reviewer;
        const stars = this.modal.querySelector('.cg-reviews-slider__modal-stars');
        const rating = Math.max(0, Math.min(5, Number(button.dataset.rating) || 0));
        stars.textContent = '★︎'.repeat(rating) + '☆︎'.repeat(5 - rating);
        stars.setAttribute('aria-label', button.closest('.cg-reviews-slider__card').querySelector('.cg-reviews-slider__stars')?.getAttribute('aria-label') || '');
        stars.hidden = rating === 0;
        this.modal.querySelector('.cg-reviews-slider__modal-verified').hidden = button.dataset.verified !== 'true';
        this.savedOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.modal.showModal();
      }, options);
      this.querySelector('[data-close-review]').addEventListener('click', () => this.modal.close(), options);
      this.modal.addEventListener('close', this.returnFocus, options);
      this.modal.addEventListener('click', event => {
        if (event.target !== this.modal) return;
        const box = this.modal.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.modal.close();
      }, options);
      this.addEventListener('pointerenter', () => { this.hovered = true; }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; }, options);
      this.querySelector('[data-pause-reviews]')?.addEventListener('click', event => {
        this.paused = !this.paused;
        event.currentTarget.setAttribute('aria-pressed', String(this.paused));
      }, options);
      window.addEventListener('resize', this.layout, options);
      if ('ResizeObserver' in window) { this.observer = new ResizeObserver(() => this.layout()); this.observer.observe(this); }
      document.addEventListener('shopify:block:select', event => {
        const i = this.cards.findIndex(card => card === event.target || card.contains(event.target));
        if (i >= 0) this.go(i, 'auto');
      }, options);
      if (this.dataset.autoplay === 'true' && this.dataset.designMode !== 'true') {
        this.autoplayTimer = setInterval(() => {
          if (this.looping && !this.paused && !this.hovered && !document.hidden && !this.modal.open && !this.contains(document.activeElement) && !matchMedia('(prefers-reduced-motion:reduce)').matches) this.go(this.current + 1);
        }, 9500);
      }
    }
    disconnectedCallback() {
      if (this.modal?.open) this.modal.close();
      this.returnFocus?.();
      this.controller?.abort();this.controller = null;
      this.observer?.disconnect();
      clearTimeout(this.normalizeTimer);clearInterval(this.autoplayTimer);
      this.track?.querySelectorAll('[data-review-clone]').forEach(card => card.remove());
      this.visible = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-why"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cg-why')) {
  customElements.define('cg-why', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.cg-why__track');
      this.cards = [...this.querySelectorAll('.cg-why__benefit')];
      this.dots = [...this.querySelectorAll('.cg-why__dots button')];
      if (!this.track || !this.cards.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.select = index => {
        const card = this.cards[index];
        if (!card) return;
        this.track.scrollTo({ left: this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.update = () => {
        const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
        let index = 0;
        let distance = Infinity;
        this.cards.forEach((card, i) => {
          const box = card.getBoundingClientRect();
          const next = Math.abs(box.left + box.width / 2 - center);
          if (next < distance) { distance = next; index = i; }
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      };
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.select(i), options));
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !matchMedia('(max-width: 1149px)').matches) return;
        const current = this.dots.findIndex(dot => dot.getAttribute('aria-current') === 'true');
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.select(Math.max(0, Math.min(this.cards.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1))));
        }
      }, options);
      window.addEventListener('resize', this.update, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
        if (index >= 0 && matchMedia('(max-width: 1149px)').matches) this.select(index);
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
